import { format } from 'date-fns';
import { collectionEngineV1 } from '../apis.js';
import { toQuery } from '@debbie/common/dist/util/index.js';
const tribunalAPIV1 = collectionEngineV1('/tribunal', true);
export const createTribunalCase = (newTribunalCase) => tribunalAPIV1('POST', `/cases`, {
    body: newTribunalCase,
});
export const getTribunalCases = (caseId, casualConsistency) => tribunalAPIV1('GET', `/cases/${caseId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const patchCase = (tribunalCaseId, patch) => tribunalAPIV1('PATCH', `/cases/${tribunalCaseId}`, {
    body: patch,
});
export const createTribunalJob = (newTribunalJob) => tribunalAPIV1('POST', `/jobs`, {
    body: newTribunalJob,
});
export const getTribunalJobs = (tribunalCaseId) => tribunalAPIV1('GET', `/jobs/${tribunalCaseId}`);
export const getMultipleTribunalJobs = (filters, page, pageSize) => tribunalAPIV1('GET', `/jobs?${toQuery({
    page,
    pageSize,
    types: filters.types,
    sortKey: filters.sortKey,
    sortDirection: filters.sortDirection,
    assignee: filters.assignee,
    states: filters.states,
    courtIds: filters.courtIds,
    toDate: filters.toDate
        ? format(new Date(filters.toDate), 'yyyy-MM-dd')
        : undefined,
    fromDate: filters.fromDate
        ? format(new Date(filters.fromDate), 'yyyy-MM-dd')
        : undefined,
    caseFilter: filters.caseFilter,
    meetingTypeIds: filters.meetingTypeIds,
})}`);
export const delJob = (jobId) => tribunalAPIV1('DELETE', `/jobs/${jobId}`);
export const patchJob = (jobId, patch) => tribunalAPIV1('PATCH', `/jobs/${jobId}`, {
    body: patch,
});
//# sourceMappingURL=tribunal.js.map